export const CURRENCY: string = 'usd';
export const THREE_DS_SDK_WEB_ID = '3dsSdk-module-iframe';
export const TABAPAY_NATIVE_TIMEOUT = 8000;
export const CHALLENGE_TIMEOUT = 5;
export const UI_TYPE = 'both';
export type TABAPAY_ENV = 'staging' | 'production';
